<template>
  <v-dialog v-model="open" max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <button type="button" class="bio-social-more" :style="{color: descriptionColor, background: chipBackground}" v-bind="attrs" v-on="on" :aria-label="$t('seeAllSocialLinks')">
        <v-icon size="18" :color="descriptionColor">mdi-dots-horizontal</v-icon>
        <span class="bio-social-more-count">+{{ links.length - visibleCount }}</span>
      </button>
    </template>
    <div class="bio-social-grid-card" :style="{background: backgroundColor}">
      <div class="bio-social-grid-header" :style="{color: titleColor}">
        <b>{{ $t('socialLinks') }}</b>
        <button type="button" class="bio-social-grid-close" :style="{background: sectionColor, color: sectionTextColor}" @click="open = false" :aria-label="$t('close')">
          <v-icon size="18" :color="sectionTextColor">mdi-close</v-icon>
        </button>
      </div>
      <div class="bio-social-grid">
        <button
          type="button"
          class="bio-social-grid-item"
          :style="{background: sectionColor, color: sectionTextColor}"
          v-for="link in links"
          :key="getItemKey(link)"
          @click="$emit('open', link.onlineAddress), open = false"
        >
          <v-icon :color="iconColor" size="26">{{ getIcon(link) }}</v-icon>
          <span>{{ link.title }}</span>
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'BioSocialLinksGrid',
  props: {
    links: { type: Array, required: true },
    visibleCount: { type: Number, default: 5 },
    iconColor: { type: String, default: '#101827' },
    descriptionColor: { type: String, default: '#5B6472' },
    backgroundColor: { type: String, default: '#FFFFFF' },
    titleColor: { type: String, default: '#101827' },
    sectionColor: { type: String, default: '#F7F5EF' },
    sectionTextColor: { type: String, default: '#101827' },
    getItemKey: { type: Function, required: true },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    // Same "iconColor + alpha" tint as the visible items in
    // BioSocialLinkCard.vue, so this trigger reads as one more chip in the
    // row rather than a visually separate control.
    chipBackground: function() {
      return `${this.iconColor}14`
    },
  },
  methods: {
    getIcon: function(link) {
      const option = this.$t('socialOptions').filter(v => v.name == link.title)[0]
      return option ? option.icon : 'mdi-link-variant'
    },
  },
}
</script>

<style scoped>
/* Same tinted-pill treatment as the visible items in BioSocialLinkCard.vue
   (see that file) - reads as one more chip in the row instead of a
   visually separate control. */
.bio-social-more {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  height: 44px;
  padding: 0 0.9rem;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: filter 0.2s ease;
}
@media (hover: hover) {
  .bio-social-more:hover {
    filter: brightness(0.94);
  }
}
.bio-social-more:active {
  filter: brightness(0.88);
}
.bio-social-more-count {
  font-size: 0.75rem;
  font-weight: 700;
}
.bio-social-grid-card {
  border-radius: 1.25rem;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
}
.bio-social-grid-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid rgba(128,128,128,0.18);
}
.bio-social-grid-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
}
.bio-social-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  padding: 1rem;
}
.bio-social-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  border: none;
  border-radius: 0.85rem;
  padding: 0.75rem 0.4rem;
  cursor: pointer;
}
.bio-social-grid-item span {
  font-size: 0.65rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
